import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { mustard } from "../styles.tsx";

const cardSx = (rotate, shadowColor) => ({
  textDecoration: "none",
  display: "block",
  bgcolor: "background.default",
  borderRadius: "4px",
  overflow: "hidden",
  transform: `rotate(${rotate}deg)`,
  boxShadow: `0 10px 0 ${shadowColor}`,
});

const BigScreenEvents = (props) => {
  return (
    <Box sx={{ bgcolor: "primary.main", px: { xs: "20px", md: "48px" }, pt: "40px", pb: "90px" }}>
      <Grid container spacing={4} justifyContent="center" alignContent="center" sx={{ maxWidth: "1200px", mx: "auto" }}>

        <Grid item xs>
          <Box component="a" href={props.link1} target="_blank" rel="noopener noreferrer" sx={cardSx(-1.5, "#ad5d4e")}>
            <Box component="img" src={props.update1} alt={props.title1} sx={{ width: "100%", aspectRatio: "4 / 5", objectFit: "cover", display: "block" }} />
            <Typography variant="h6" sx={{ px: "16px", py: "14px", color: "primary.main" }}>
              {props.title1}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs>
          <Box component="a" href={props.link2} target="_blank" rel="noopener noreferrer" sx={{ ...cardSx(1, mustard), mt: "24px" }}>
            <Box component="img" src={props.update2} alt={props.title2} sx={{ width: "100%", aspectRatio: "4 / 5", objectFit: "cover", display: "block" }} />
            <Typography variant="h6" sx={{ px: "16px", py: "14px", color: "primary.main" }}>
              {props.title2}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs>
          <Box component="a" href={props.link3} target="_blank" rel="noopener noreferrer" sx={cardSx(-0.75, "#ad5d4e")}>
            <Box component="img" src={props.update3} alt={props.title3} sx={{ width: "100%", aspectRatio: "4 / 5", objectFit: "cover", display: "block" }} />
            <Typography variant="h6" sx={{ px: "16px", py: "14px", color: "primary.main" }}>
              {props.title3}
            </Typography>
          </Box>
        </Grid>

      </Grid>
    </Box>
  );
};

export default BigScreenEvents;
